"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.mediaQueries = exports.breakpoints = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoints = ['40em', '52em', '64em'];
exports.breakpoints = breakpoints;
var mediaQueries = (0, _map2.default)(breakpoints, function (breakpoint) {
  return "@media screen and (min-width: " + breakpoint + ")";
});
exports.mediaQueries = mediaQueries;
var media = {
  small: function small(css) {
    return "@media screen and (min-width: " + breakpoints[0] + ") { " + css + " }";
  },
  medium: function medium(css) {
    return "@media screen and (min-width: " + breakpoints[1] + ") { " + css + " }";
  },
  large: function large(css) {
    return "@media screen and (min-width: " + breakpoints[2] + ") { " + css + " }";
  }
};
exports.media = media;